import ActionTypes from './types';
import store from '../store/configureStore';
import {parkingSpotsGroupedBy, removeElement} from '../utils';


export const setAllFilterOptions = () => {
  const spotsGroupedBySurface = parkingSpotsGroupedBy('surface', 'OPEN');
  const spotsGroupedBySize = parkingSpotsGroupedBy('size', 'OPEN');

  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_FILTER_OPTIONS,
      filterOptions: { sizes: spotsGroupedBySize, surface: spotsGroupedBySurface }
    });
  };
};

export const toggleFilter = (entity, filter) => {
  let filters = Object.assign({}, store.getState().search.appliedFilters);
  const appliedFiltersForEntity = filters[entity];

  if (filter === 'All') {
    filters[entity] = [];
  } else if(appliedFiltersForEntity.includes(filter)) {
    filters[entity] = removeElement(appliedFiltersForEntity, filter);
  } else {
    filters[entity] = [...appliedFiltersForEntity, filter];
  }

  return (dispatch) => {
    dispatch({
      type: ActionTypes.APPLY_FILTERS,
      appliedFilters: filters
    });
  };
};

export const clearFilters = () => {
  return (dispatch) => {
    dispatch(processFilter([], []));
    dispatch({
      type: ActionTypes.RESET_FILTERS
    });
  };
};

export const processFilter = (availableFilteredSpots, allSpotsForFilter) => {
  return (dispatch) => {

    dispatch({
      type: ActionTypes.SET_FILTERED_SPOTS,
      availableFilteredSpots: availableFilteredSpots,
      allFilteredSpots: allSpotsForFilter
    });

    dispatch({
      type: ActionTypes.SET_NAV_SEARCH_STATE,
      isSearchFormOpened: false
    });

    dispatch({
      type: ActionTypes.RESET_MAP
    });

  };
};



// WEBPACK FOOTER //
// ./src/actions/filters.js